import { useState, useRef } from "react";
import styles from "./index.module.scss";
import { formatCurrency, pstDateFormat } from "../../../utils/utils";

type OfferHistory = {
  offerSubmittedDate: string;
  offerAmount: number;
};

interface CustomAccordionProps {
  header: string;
  offers: OfferHistory[];
}

const CustomAccordion = ({ header, offers }: CustomAccordionProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const contentRef = useRef<HTMLDivElement>(null); // Reference to get height

  const toggleAccordion = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className={styles.accordion}>
      <div className={styles.header}>
        <>
          {!isOpen ? (
            <img
              src="/images/DownArrowSide.svg"
              alt=""
              onClick={(e) => {
                e.stopPropagation();
                toggleAccordion();
              }}
            />
          ) : (
            <img
              src="/images/RightArrow.svg"
              alt=""
              onClick={(e) => {
                e.stopPropagation();
                toggleAccordion();
              }}
            />
          )}
        </>
        <div
          className={styles.title}
          onClick={(e) => {
            e.stopPropagation();
            toggleAccordion();
          }}
        >
          {header}
        </div>
      </div>
      <div
        ref={contentRef}
        className={`${styles.content} ${isOpen ? styles.open : ""}`}
        style={{
          maxHeight: isOpen ? `${contentRef.current?.scrollHeight}px` : "0px"
        }}
      >
        {offers.length > 0 ? (
          <div className={styles.offerHistoryWrap}>
            {offers.map((history: any) => (
              <div
                key={history.offerSubmittedDate}
                className={styles.offerHistory}
              >
                <div
                  className={styles.nameDateWrap}
                >
                  <span className={styles.name}>
                    {history.firstName} {history.lastName}
                  </span>
                  <span className={styles.date}>
                    {pstDateFormat(history.offerSubmittedDate)}
                  </span>
                </div>
                <span className={styles.price}>
                  {formatCurrency(history.offerAmount)}
                </span>
              </div>
            ))}
          </div>
        ) : (
          <p>No offers available</p>
        )}
      </div>
    </div>
  );
};

export default CustomAccordion;
